import { Grid, Typography, Card, Badge, Box } from "@material-ui/core";
import { mainContentColor, modalStressTextColor, subContentColor } from "../lib/Color";
import { PlayerType, PositionType, TeamType } from "../Type/TeamType";
import BattleResultTeamMemberStatus from "./BattleResultTeamMemberStatus";

export type BattleResultLineType = {
    active_hero: string,
    active_position_type: PositionType,
    active_skill_effects: string[],
    active_skill_name: number,
    active_team_type: PlayerType,
    attack_team: BattleResultLineTeamType,
    defence_team: BattleResultLineTeamType
}

export type BattleResultLineTeamType = {
    back: BattleResultLineTeamPositionType
    front: BattleResultLineTeamPositionType
    middle: BattleResultLineTeamPositionType
}

export type BattleResultLineTeamPositionType = {
    hp: number,
    phy: number,
    int: number,
    agi: number,
    change_hp: number,
    change_phy: number,
    change_int: number,
    change_agi: number,
}

type Props = {
    teamCount: number,
    selectedAttackTeam: TeamType
    selectedDefenceTeam: TeamType
} & BattleResultLineType

const BattleResultLine = ({
    teamCount,
    selectedAttackTeam,
    selectedDefenceTeam,
    active_hero,
    active_position_type,
    active_skill_effects,
    active_skill_name,
    active_team_type,
    attack_team,
    defence_team,
}: Props) => {
    const getActiveTeamMember = (team: TeamType, positionType: PositionType) => {
        switch (positionType) {
            case "FRONT":
                return team.front;
            case "MIDDLE":
                return team.middle;
            case "BACK":
                return team.back;
        }
    }

    const activeTeam = active_team_type === "Attack" ? selectedAttackTeam : selectedDefenceTeam
    const activeMember = getActiveTeamMember(activeTeam, active_position_type)

    return (
        <>
            <Box style={{
                position: "absolute",
                background: active_team_type === "Attack" ? "red" : "blue",
                borderRadius: "10px"
            }}>
                <Typography variant="h6" style={{ color: modalStressTextColor, margin: "5px" }}>
                    {teamCount + 1}:{active_position_type}
                </Typography>
            </Box>
            <Grid item style={{ margin: "10px", backgroundColor: subContentColor }}>
                <Grid container >
                    <Grid item xs={3} style={{
                        textAlign: 'center',
                        justifyContent: 'center',
                        alignContent: 'center',
                    }}>
                        <Card style={{ background: mainContentColor, margin: "10px" }}>
                            <img
                                src={`https://www.mycryptoheroes.net/images/heroes/2000/${activeMember.hero?.id}.png`}
                                style={{ width: 128, height: 128 }}
                            />
                        </Card>
                    </Grid>
                    <Grid item xs={9}>
                        <Card style={{ background: mainContentColor, margin: "10px", height: "90%" }}>
                            <Typography style={{ color: modalStressTextColor, margin: "10" }}>skill {active_skill_name}</Typography>
                            {active_skill_effects.map((effect, key) =>
                                <Typography key={key} style={{ color: modalStressTextColor, margin: "10" }}> {effect}</Typography>
                            )}
                        </Card>
                    </Grid>
                    <BattleResultTeamMemberStatus team={selectedAttackTeam} battleResult={attack_team} />
                    <BattleResultTeamMemberStatus team={selectedDefenceTeam} battleResult={defence_team} />
                </Grid>
            </Grid >
        </>
    );
}

export default BattleResultLine;